import { createStore } from 'vuex'

export const store = createStore({
    state() {
        return {
            kidoku_sw: false,  // 既読のお知らせを表示しない
            current_page: 1,   // 現在のページ（管理者側体験プログラム一覧）
            current_page_user: 1,   // 現在のページ（管理者側ユーザー一覧）
            current_page_check: 1,   // 現在のページ（管理者側チェックイン状況画面）
            current_page_rireki: 1,   // 現在のページ（管理者側操作履歴画面）
            
            taiken: {}, // 体験プログラムの検索項目（ユーザー側）
            gyo_count: 30, // 体験プログラムの表示件数（ユーザー側）
            access_shakyo : "",// アクセスした社協の情報
            forgot_email : "",// パスワードを忘れたメールアドレス
            
            return_cmd : "", // お知らせから戻り先のコマンド
            return_id : "",// お知らせから戻り先のID（IDが必要な場面に限る）
            
            taikenuser: {}, // 体験ユーザーの検索項目（管理側）

            checkin_kaisai_start: "",// チェックイン状況画面の開催日（絞り込み、管理側）
            checkin_kaisai_end: "",// チェックイン状況画面の開催日（絞り込み、管理側）
            checkin_syurui: 2,// チェックイン状況画面の種類（絞り込み、管理側）
            checkin_TabActive: 'Tab1',// チェックイン状況画面のアクティブタブ（絞り込み、管理側）
            checkin_read_count: 50,// チェックイン状況画面の表示件数（管理側）
            checkin_read_start: 0,// チェックイン状況画面の読み込み数（管理側）
            checkin_order: "",// チェックイン状況画面の並び替え項目（絞り込み、管理側）
            checkin_mode: "",// チェックイン状況画面の昇順・降順（絞り込み、管理側）
            first_disp :0,
            
            mail_send_date: "",// メール送信履歴画面の送信日（絞り込み、管理側）
            mail_start_date: "",// メール送信履歴画面の送信日（絞り込み、管理側）
            mail_end_date: "",// メール送信履歴画面の送信日（絞り込み、管理側）
            mail_kubun: 0,// メール送信履歴画面の区分（絞り込み、管理側）
            mail_syurui: 100,// メール送信履歴画面の種類（絞り込み、管理側）
            mail_kidoku: 0,// メール送信履歴画面の既読・未読（絞り込み、管理側）
            mail_order: "",// メール送信履歴画面の並び替え項目（絞り込み、管理側）
            mail_mode: "",// メール送信履歴画面の昇順・降順（絞り込み、管理側）
            mail_page: "",// メール送信履歴画面の読み込みページ（絞り込み、管理側）
            mail_read_count: "",// メール送信履歴画面の読み込み数（絞り込み、管理側）

            
            return_taiken_id : 0,// 参加状況【事前説明会】【事後集会】からの戻り先の体験プログラムID
            return_moshikomi_count : 0,// 参加状況【事前説明会】【事後集会】からの戻り先の体験プログラムの申込回数

            moshikomi_nothing:false, // 体験プログラム情報：申込の無いプログラムのみ表示するかどうか（管理側）

        }
    }
    
})